import Sidebar from './Sidebar'
import { useTheme } from '../context/ThemeContext'

export default function Layout({ children }) {
  const { theme } = useTheme();
  
  return (
    <div className="flex flex-col md:flex-row h-screen bg-gray-100 dark:bg-dark-bg transition-colors duration-300">
      <Sidebar />
      <main className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6 dark:text-dark-text">
        {children}
      </main>
    </div>
  )
}
